module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-1"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-1-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-1-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("W")]), _vm._v("hen the smiling anaesthetist leaned over Eban’s scrubbed and prepped body, he asked him to count backwards from ten. The anaesthetic pressed down upon him in what felt like a relentless wave of shimmering, chemical subjugation.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A calm voice in his head told him that he was about to die for some short while.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But unlike Elvis, he would never leave the building.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Momentarily, a brief eddy of recent and long passed memories bled together.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But no corridor of light.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("No celestial waiting room for him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Just the clunk and hiss of pumps and tubes. Pushing thin red lines down drip, up catheter. Nothingness.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Not fear. Nor regret.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Nor suffering.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Nor loss")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Just void.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Until returning, dulled and sore, perhaps to touch her hand and see her face again.")]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("7")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018ed2aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-001.vue
// module id = 78
// module chunks = 0